import { FC, memo, ComponentProps } from 'react';

import { RemoteImage } from '@gem/modules/remote-storage';

export interface IIconCurrentReactionProps extends ComponentProps<'img'> {
  src: string;
}

export const IconCurrentReaction: FC<IIconCurrentReactionProps> = memo(({ src, ...props }) => {
  return (
    <RemoteImage
      src={src}
      alt=""
      {...props}
    />
  );
});
